/* eslint no-unused-expressions: 0 */
import * as Yup from "yup";

import { FormikValues } from "formik";

import { getValidationSchemaByName } from "./validations.map";

import { IFormFactoryData, IFormFactoryInput, IFormFactoryItem } from "./types";

const assignValue = (
  initialValues: FormikValues,
  name: string,
  value: any,
): void => {
  initialValues[name] = value || "";
};

const processSubitem = (
  subitem: IFormFactoryInput,
  initialValues: FormikValues,
): void => {
  assignValue(initialValues, subitem.name, subitem.value);
};

const processItem = (
  item: IFormFactoryItem,
  initialValues: FormikValues,
): void => {
  if (item.inputs && item.inputs.length > 0) {
    item.inputs.forEach((subitem) => {
      processSubitem(subitem, initialValues);
    });
  }

  if (item.name) {
    assignValue(initialValues, item.name, item.value);
  }
};

const processGroup = (
  group: IFormFactoryData,
  initialValues: FormikValues,
): void => {
  if ("items" in group) {
    group.items.forEach((item) => {
      processItem(item, initialValues);
    });
  }
};

export const getInitialValues = (groups: IFormFactoryData[]): FormikValues => {
  const initialValues = {};

  groups.forEach((group) => {
    processGroup(group, initialValues);
  });

  return initialValues;
};

const assignSchema = (yupValidation: any, key: string, schema: any): void => {
  yupValidation[key] = schema;
};

const processValidation = (
  key: string,
  validation: any,
  yupValidation: any,
): void => {
  const schema = getValidationSchemaByName(validation);
  assignSchema(yupValidation, key, schema);
};

const mapValidationSchema = (validations: any): any => {
  const yupValidation = {};

  Object.keys(validations).forEach((key) => {
    processValidation(key, validations[key], yupValidation);
  });

  return yupValidation;
};

const assignValidation = (
  validations: any,
  name: any,
  validation: any,
): void => {
  validations[name] = validation;
};

const processSubitemForValidations = (
  subitem: IFormFactoryInput,
  validations: any,
): void => {
  if (subitem.validations) {
    assignValidation(validations, subitem.name, subitem.validations);
  }
};

const processItemForValidations = (
  item: IFormFactoryItem,
  validations: any,
): void => {
  if (item.inputs && item.inputs.length > 0) {
    item.inputs.forEach((subitem) => {
      processSubitemForValidations(subitem, validations);
    });
  }

  if (item.validations) {
    assignValidation(validations, item.name, item.validations);
  }
};

const processGroupForValidations = (
  group: IFormFactoryData,
  validations: any,
): void => {
  if ("items" in group) {
    group.items.forEach((item) => {
      processItemForValidations(item, validations);
    });
  }
};

export const getValidationSchema = (groups: IFormFactoryData[]): any => {
  const validations = {};

  groups.forEach((group) => {
    processGroupForValidations(group, validations);
  });

  const validationSchema = mapValidationSchema(validations);

  return Object.keys(validationSchema).length
    ? Yup.object().shape(validationSchema)
    : null;
};
